import { render } from "./SaleDocPaymentPref.vue?vue&type=template&id=32accac9&scoped=true"
import script from "./SaleDocPaymentPref.vue?vue&type=script&lang=js"
export * from "./SaleDocPaymentPref.vue?vue&type=script&lang=js"

import "./SaleDocPaymentPref.vue?vue&type=style&index=0&id=32accac9&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32accac9"]])

export default __exports__